import React from "react";
import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Icon } from "@iconify/react";
function mapStateToProps(state) {
  return { selectMenu: state.selectedMenu };
}
class LeftNavbar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeKey: this.props.activeKey,
      propertyType: this.props.propertyType,
      selectMenu: "",
    };
  }
  // componentDidMount(){
  //   this.setState({
  //     selectMenu: '',
  //   });
  // }
  componentDidUpdate() {
    if (
      this.props.selectMenu != "" &&
      this.props.selectMenu != this.state.selectMenu
    ) {
      this.setState({
        selectMenu: this.props.selectMenu,
        activeKey: this.props.activeKey,
      });
      this.props.dispatch({
        type: "CHANGE_SELECTED_SIDE_MENU",
        selectMenuNew: "",
      });
    } else if (this.props.selectMenu != this.state.selectMenu) {
      this.setState({ selectMenu: "" });
    }
  }
  render() {
    return (
      <div className="leftNav">
        <ul>
          <li
            className={this.state.activeKey === "Dashboard" ? "activeLi" : ""}
          >
            <Link
              to={
                `/${this.state.propertyType}/dashboard/` +
                this.props.location.search
              }
              className={
                this.state.activeKey === "Dashboard" ? "activeNav" : ""
              }
              onClick={() => {
                this.setState({ activeKey: "Dashboard" });
                // var path = appConfigs.appPath+`/dashboard/`+window.location.search;
                // window.location.href = path;
                // // this.props.history.push({
                // //   pathname:
                // //     `/`,
                // // });
                this.props.dispatch({
                  type: "HIDE_FILTER_DIV",
                  payload: { showFilterDiv: false },
                });
              }}
            >
              <p className="text-center">
                {/* <img
                  alt="Dashbord Icon"
                  src={
                    this.state.activeKey === "Dashboard"
                      ? "/edge/images/dashboard_active.png"
                      : "/edge/images/dashboard.png"
                  }
                /> */}
                <Icon icon="material-symbols:dashboard" />
              </p>
              <p className="text-center">Dashboard</p>
            </Link>
          </li>
          <li
            className={
              this.state.activeKey === "Micromarket" ||
              this.state.activeKey === "Macromarket" ||
              this.state.activeKey === "Market"
                ? "activeLi"
                : ""
            }
          >
            <Link
              to={
                `/${this.state.propertyType}/region/` +
                this.props.location.search
              }
              className={
                this.state.activeKey === "Micromarket" ||
                this.state.activeKey === "Macromarket" ||
                this.state.activeKey === "Market"
                  ? "activeNav"
                  : ""
              }
              onClick={() => {
                this.setState({ activeKey: "Market" });
                this.props.dispatch({
                  type: "HIDE_FILTER_DIV",
                  payload: { showFilterDiv: false },
                });
                // this.props.appConfigs.appPath+history.push(
                //   `/region/1`
                // );
                // var path = appConfigs.appPath+`/region/`+window.location.search;
                // window.location.href = path;
              }}
            >
              <p className="text-center">
                {/* <img
                  alt="Region Icon"
                  src={
                    this.state.activeKey === "Micromarket" ||
                    this.state.activeKey === "Macromarket" ||
                    this.state.activeKey === "Market"
                      ? "/edge/images/region_active.png"
                      : "/edge/images/region.png"
                  }
                /> */}
                <Icon icon="mdi:location" />
              </p>
              <p className="text-center">Region</p>
            </Link>
          </li>
          <li
            className={this.state.activeKey === "Developer" ? "activeLi" : ""}
          >
            <Link
              to={`/${this.state.propertyType}/developer/${this.props.location.search}`}
              className={
                this.state.activeKey === "Developer" ? "activeNav" : ""
              }
              onClick={() => {
                this.setState({ activeKey: "Developer" }); 
                this.props.dispatch({
                  type: "HIDE_FILTER_DIV",
                  payload: { showFilterDiv: false },
                });
              }}
            >
              <p className="text-center">
                {/* <img
                  alt="Developer Icon"
                  src={
                    this.state.activeKey === "Developer"
                      ? "/edge/images/developer_active.png"
                      : "/edge/images/developer.png"
                  }
                /> */}
                <Icon icon="bi:buildings-fill" />
              </p>
              <p className="text-center">Developer</p>
            </Link>
          </li>
          {/* <li className={this.state.activeKey === "Owner" ? "activeLi" : ""}>
            <Link
              to={`/${this.state.propertyType}/owner/${this.props.location.search}`}
              className={this.state.activeKey === "Owner" ? "activeNav" : ""}
              onClick={() => {
                this.setState({ activeKey: "Owner" });
                this.props.dispatch({
                  type: "HIDE_FILTER_DIV",
                  payload: { showFilterDiv: false },
                });
              }}
            >
              <p className="text-center">
                <img
                  alt="Owner Icon"
                  src={
                    this.state.activeKey === "Owner"
                      ? "/edge/images/owner_active.png"
                      : "/edge/images/owner.png"
                  }
                />
              </p>
              <p className="text-center">Owner</p>
            </Link>
          </li> */}
          <li className={this.state.activeKey === "Property" ? "activeLi" : ""}>
            <Link
              to={`/${this.state.propertyType}/asset/${this.props.location.search}`}
              className={this.state.activeKey === "Property" ? "activeNav" : ""}
              onClick={() => {
                this.setState({ activeKey: "Property" });
                this.props.dispatch({
                  type: "HIDE_FILTER_DIV",
                  payload: { showFilterDiv: false },
                });
              }}
            >
              <p className="text-center">
                {/* <img
                  alt="Asset Icon"
                  src={
                    this.state.activeKey === "Property"
                      ? "/edge/images/asset_active.png"
                      : "/edge/images/asset.png"
                  }
                /> */}
                <Icon icon="bi:houses-fill" />
              </p>
              <p className="text-center">Asset</p>
            </Link>
          </li>
          <li className={this.state.activeKey === "Tenant" ? "activeLi" : ""}>
            <Link
              to={`/${this.state.propertyType}/occupier/${this.props.location.search}`}
              className={this.state.activeKey === "Tenant" ? "activeNav" : ""}
              onClick={() => {
                this.setState({ activeKey: "Tenant" });
                this.props.dispatch({
                  type: "HIDE_FILTER_DIV",
                  payload: { showFilterDiv: false },
                });
              }}
            >
              <p className="text-center">
                {/* <img
                  alt="occupier Icon"
                  src={
                    this.state.activeKey === "Tenant"
                      ? "/edge/images/occupier_active.png"
                      : "/edge/images/occupier.png"
                  }
                /> */}
                <Icon icon="fa-solid:house-user" />
              </p>
              <p className="text-center">Occupier</p>
            </Link>
          </li>
          <li className={this.state.activeKey === "Map" ? "activeLi" : ""}>
            <Link
              to={`/${this.state.propertyType}/map/${this.props.location.search}`}
              className={this.state.activeKey === "Map" ? "activeNav" : ""}
              onClick={() => {
                this.setState({ activeKey: "Map" });
                this.props.dispatch({
                  type: "HIDE_FILTER_DIV",
                  payload: { showFilterDiv: false },
                });
              }}
            >
              <p className="text-center">
                {/* <img
                  alt="map Icon"
                  src={
                    this.state.activeKey === "Map"
                      ? "/edge/images/map_active.png"
                      : "/edge/images/map.png"
                  }
                /> */}
                <Icon icon="clarity:map-solid" />
              </p>
              <p className="text-center">Map</p>
            </Link>
          </li>
          <li className={this.state.activeKey === "Custom" ? "activeLi" : ""}>
            <Link
              to={`/${this.state.propertyType}/custom/${this.props.location.search}`}
              className={this.state.activeKey === "Custom" ? "activeNav" : ""}
              onClick={() => {
                this.setState({ activeKey: "Custom" });
                this.props.dispatch({
                  type: "HIDE_FILTER_DIV",
                  payload: { showFilterDiv: false },
                });
              }}
            >
              <p className="text-center">
                {/* <img
                  alt="custom Icon"
                  src={
                    this.state.activeKey === "Custom"
                      ? "/edge/images/custom_active.png"
                      : "/edge/images/custom.png"
                  }
                /> */}
                <Icon icon="bi:stack" />
              </p>
              <p className="text-center">Custom</p>
            </Link>
          </li>

          <li
            className={this.state.activeKey === "Transaction" ? "activeLi" : ""}
          >
            <Link
              to={`/${this.state.propertyType}/transaction/${this.props.location.search}`}
              className={
                this.state.activeKey === "Transaction" ? "activeNav" : ""
              }
              onClick={() => {
                this.setState({ activeKey: "Transaction" });
                this.props.dispatch({
                  type: "HIDE_FILTER_DIV",
                  payload: { showFilterDiv: false },
                });
              }}
            >
              <p className="text-center">
                {/* <img
                  alt="transaction Icon"
                  src={
                    this.state.activeKey === "Transaction"
                      ? "/edge/images/transactions_active.png"
                      : "/edge/images/transactions.png"
                  }
                /> */}
                <Icon icon="tabler:arrows-exchange" />
              </p>
              <p className="text-center">Transaction</p>
            </Link>
          </li>
          {/* <li className={this.state.activeKey === "Myoc" ? "activeLi" : ""}>
            <Link
              to={`/office/make-your-chart`}
              className={this.state.activeKey === "Myoc" ? "activeNav" : ""}
              onClick={() => {
                this.setState({ activeKey: "Myoc" });
                this.props.dispatch({
                  type: "HIDE_FILTER_DIV",
                  payload: { showFilterDiv: false },
                });
              }}
            >
              <p className="text-center">
                <img
                  alt="Myoc Icon"
                  src={
                    this.state.activeKey === "Myoc"
                      ? "/edge/images/transactions_active.png"
                      : "/edge/images/transactions.png"
                  }
                />
              </p>
              <p className="text-center">MYOC</p>
            </Link>
          </li> */}
        </ul>
      </div>
    );
  }
}

export default connect(mapStateToProps)(withRouter(LeftNavbar));
// export default LeftNavbar;
